import axios from "axios";
import { CreateAthletePayload } from "./Models/types";
import { getData } from "../contexts/authContext";
import qs from "qs";
/* eslint-disable @typescript-eslint/no-explicit-any */

export const createPatientOnInvitePromise = async (
  payload: CreateAthletePayload
) => {
  const token = await getData("idToken");

  const { data } = await axios.post(
    `${process.env.REACT_APP_BASE_URL}/patient`,
    payload,
    {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    }
  );
  return data;
};

export const generatePatientReport = async (patientId: string) => {
  const token = await getData("idToken");

  const { data } = await axios.post(
    `${process.env.REACT_APP_BASE_URL}/patient/generate-report`,
    { patientId },
    {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    }
  );
  return data;
};

export const uploadLoadTest = async (payload: any) => {
  const token = await getData("idToken");

  const { data } = await axios.post(
    `${process.env.REACT_APP_BASE_URL}/patient/load-test-upload`,
    payload,
    {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    }
  );
  return data;
};

export const postPerformanceReport = async (payload: any) => {
  const token = await getData("idToken");

  const { data } = await axios.post(
    `https://i8xa1zlcxd.execute-api.us-east-1.amazonaws.com/staging/performance-reports`,
    payload,
    {
      headers: {
        Authorization: `Bearer ${token}`,
      },
      timeout: 30000,
    }
  );
  return data;
};

export const getPatientOverView = async () => {
  const token = await getData("idToken");
  const currentDate = new Date(); // Get the current date and time
  currentDate.setDate(currentDate.getDate() - 31); // Subtract 31 days from the current date
  const { data } = await axios.get(
    `${
      process.env.REACT_APP_BASE_URL
    }/patient/clinic-overview?startDate=${currentDate.toISOString()}`,
    {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    }
  );
  return data;
};

export const getAthleteLeaderboard = async (
  filters?: any,
  inverted = false
) => {
  const token = await getData("idToken");
  const options = {
    params: {
      ...(filters || {}),
      inverted: inverted?.toString(),
    },
    headers: {
      Authorization: `Bearer ${token}`,
    },
    paramsSerializer: (params: any) => {
      return qs.stringify(params, { arrayFormat: "brackets" });
    },
  };

  const { data } = await axios.get(
    `${process.env.REACT_APP_BASE_URL}/patient/leaderboard?limit=1000` /* /patient/leaderboard */,
    options
  );
  return data;
};

export const getAthleteAverages = async (patientIds?: string[]) => {
  const token = await getData("idToken");
  const options = {
    /* params: {
      ...(filters || {}),
    }, */
    headers: {
      Authorization: `Bearer ${token}`,
    },

    /*  paramsSerializer: (params: any) => {
      return qs.stringify(params, { arrayFormat: "brackets" });
    }, */
  };

  const { data } = await axios.post(
    `${process.env.REACT_APP_BASE_URL}/patient/averages-by-patients`,
    { patientIds },
    options
  );
  return data;
};

export const getGroupComparison = async (payload: any) => {
  const token = await getData("idToken");
  const options = {
    headers: {
      Authorization: `Bearer ${token}`,
    },
  };

  const { data } = await axios.post(
    `${process.env.REACT_APP_BASE_URL}/patient/side-by-side`,
    { ...payload },
    options
  );
  return data;
};

export const getAthleteFullList = async () => {
  const token = await getData("idToken");
  const { data } = await axios.get(
    `${process.env.REACT_APP_BASE_URL}/patient-region/athletes?sortBy=name&sortDirection=DESC&limit=1000&offset=0`,
    {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    }
  );
  return data;
};
